import * as React from 'react';
import '../App.css';
import Appbar from '../component/appbar';
import Foot from '../component/foot';

import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { Box } from '@mui/material';



function Page1() {
    return (
        <div className="App">
            <Appbar />
            <header className="App-header" sx={{ py: 7}}>
                <Box sx={{ display: 'flex', flexWrap: 'wrap' , justifyContent: 'center'}}>
                <Card sx={{ maxWidth: 500, m: 3}}>
                    <CardMedia
                        sx={{ height: 350 }}
                        image="https://th.bing.com/th/id/R.e6ac556d4ff7969dda32a82307fb372f?rik=Z6Q79yn3%2bo3OBA&riu=http%3a%2f%2fupload.wikimedia.org%2fwikipedia%2fcommons%2f2%2f25%2fBangkok_Reptiles_Blue_crested_Lizard.jpg&ehk=OjGCdLaNX8IsxLidsQ0JYE5oDfXMb4Lbd1L6rtt3Ahc%3d&risl=&pid=ImgRaw&r=0"
                        title="green iguana"
                    />
                    <CardContent>
                        <Typography gutterBottom variant="h5" component="div">
                            Lizard
                        </Typography>
                        <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                            Lizards are a widespread group of squamate reptiles, with over 6,000
                            species, ranging across all continents except Antarctica
                        </Typography>
                    </CardContent>
                    <CardActions>
                        <Button size="small">Share</Button>
                        <Button size="small">Learn More</Button>
                    </CardActions>
                </Card>

                <Card sx={{ maxWidth: 500, m: 3 }}>
                    <CardMedia
                        sx={{ height: 350 }}
                        image="https://th.bing.com/th/id/R.269449bf98e51a623e53dc336ab66159?rik=Z4AfwUnuX1NrlA&riu=http%3a%2f%2fwww.australiananimallearningzone.com%2fwp-content%2fuploads%2f2012%2f09%2fFrilled-Lizard.jpg&ehk=5NdyOZ9eMcy%2fIXfgYohubFomiapBCGkzXPuayh9PhiU%3d&risl=&pid=ImgRaw&r=0"
                        title="green iguana"
                    />
                    <CardContent>
                        <Typography gutterBottom variant="h5" component="div">
                            Lizard
                        </Typography>
                        <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                            Lizards are a widespread group of squamate reptiles, with over 6,000
                            species, ranging across all continents except Antarctica
                        </Typography>
                    </CardContent>
                    <CardActions>
                        <Button size="small">Share</Button>
                        <Button size="small">Learn More</Button>
                    </CardActions>
                </Card>
                </Box>
            </header>
            <Foot />
        </div>
    );
}

export default Page1;